import React, { useRef, useCallback } from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import styles from "./walkTestSecondStep.module.css";

function openPicker(input) {
    if (!input) return;
    if (typeof input.showPicker === "function") {
        try {
            input.showPicker();
            return;
        } catch {
            // showPicker can throw if not user-gesture; focus as fallback
        }
    }
    input.focus();
}

const DateTimeField = React.forwardRef(function DateTimeField(
    { type = "time", className = "", disabled, ...inputProps },
    ref,
) {
    const localRef = useRef(null);
    const Icon = type === "date" ? CalendarMonthIcon : AccessTimeIcon;

    const setRefs = useCallback(
        (node) => {
            localRef.current = node;
            if (typeof ref === "function") {
                ref(node);
            } else if (ref) {
                ref.current = node;
            }
        },
        [ref],
    );

    return (
        <div className={styles.dateTimeInputWrapper}>
            <input
                ref={setRefs}
                type={type}
                disabled={disabled}
                className={`${styles.dateTimeInput} ${className}`.trim()}
                {...inputProps}
            />
            {!disabled ? (
                <button
                    type="button"
                    className={styles.dateTimePickerTrigger}
                    onClick={() => openPicker(localRef.current)}
                    tabIndex={-1}
                    aria-label={
                        type === "date"
                            ? "Open calendar"
                            : "Open time picker"
                    }
                >
                    <Icon
                        sx={{
                            fontSize: 20,
                            color: "var(--primary-theme-color)",
                        }}
                    />
                </button>
            ) : (
                <span
                    className={styles.dateTimePickerTrigger}
                    aria-hidden
                    style={{ opacity: 0.55, pointerEvents: "none" }}
                >
                    <Icon
                        sx={{
                            fontSize: 20,
                            color: "var(--primary-theme-color)",
                        }}
                    />
                </span>
            )}
        </div>
    );
});

export default DateTimeField;
